import classnames from "classnames";
import { omit } from "lodash";
import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactLoading from "react-loading";
import { connect } from "react-redux";
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import addUsersImage from "../../../files/add-users.png";
import ActivePatientList from "./ActivePatientList";
import CreateUserModal from "./CreateUserModal";
import Heading from "./Heading";
import CreateSharedAccountModal from "./CreateSharedAccountModal";
import familyAccount from "../../../files/ic_family_account.svg";
import ResetPassword from "./ResetPassword";
import { patientsTab, USER_STATUS } from "../../../constants/general.constant";
import queryString from 'query-string';
import usersImage from "../../../files/users.png";
import EducationMaterialSentPatients from "../../EducationMaterialSentPatients";
import RpmCarePlanList from "../../RpmCarePlanList";
import "./PatientsDashboard.css";

// DashboardCard Component - Reusable card component for patient dashboard
const DashboardCard = ({ title, count, icon, color, onClick, isActive }) => (
  <div className={`dashboard-card ${isActive ? 'active' : ''}`} onClick={onClick}>
    <div className="dashboard-card-body">
      <div className={`left-border ${color}`} />
      <div className="card-content-area">
        <i className={`${icon} card-icon ${isActive ? 'active-icon' : ''}`} />
        <div className="card-text">
          <h5 style={{fontWeight : 900}}>{title}</h5>
          <h3>{count}</h3>
        </div>
      </div>
    </div>
  </div>
);

const MENU_API = {
  ALL_PATIENT: "AllPatient",
  ACTIVE_PATIENT: "Active",
  IN_ACTIVE_PATIENT: "InActive",
  DEMO_PATIENT: "Demo",
  CALLER_PATIENT: "Caller",
  NEED_TO_FOLLOW_UP:"NeedToFollowUp",
  HOSPITAL_ADMINSSON:"HospitalAdmission",
  IT_ISSUES : "ItIssues",
  FOLLOW_UP_REMINDERS : 'FollowUpReminder',
  REMINDER_SENT : 'ReminderSent',
  WANRNING_ADHERENCE : 'WarningAdherence',
  MONTHLY_CHECK_IN_PHONE_CALL : 'MonthlyCheckInPhoneCall',
  FOLLOW_UP_PHONE_CALL : 'FollowUpPhoneCall',
  EDUCATION_MATERIAL : 'EducationMaterial',
  WINS_POSITIVE_OUTCOME: 'WinsPositiveOutcome',
  RPM_CARE_PLAN: 'RpmCarePlan'
}
class AdminAnalytics extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      sharedmodal: false,
      activeTab: "1",
      modal: false,
      modal2: false,
      modalUser: false,
      modalReset: false,
      emailOffer: "",
      emailAccess: "",
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      subOrganization: "",
      gender: "Male",
      showAlertSuccess: false,
      errorPassword: false,
      isClient: true,
      resetFullname: "",
      resetPatientId: "",
      showWarning: false,
      careprovider: false,
      displayActiveList: true,
      displayDemoList: null,
      insuranceProvider: "",
      enrolledPrograms: "",
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayItIssuesList : false,
      loading: true,
      selectedApi: "Active",
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      modalShared: false,
      role: "",
      approvalStatus: USER_STATUS.APPROVED,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall : false,
      displayEducationMaterialCard: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      educationPatientsCount : null,
      hospitalPatientsCount : null
    };
    this.toggleUser = this.toggleUser.bind(this);
    this.toggleReset = this.toggleReset.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.submitReset = this.submitReset.bind(this);
    this.submitResetPassword = this.submitResetPassword.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.resetStateBack = this.resetStateBack.bind(this);
    this.child = React.createRef();
    this.toggleShared = this.toggleShared.bind(this);
    this.submitShared = this.submitShared.bind(this);
    this.toggleSharedModal = this.toggleSharedModal.bind(this);
    this.handleRole = this.handleRole.bind(this);
    this.updateEducationCount = this.updateEducationCount.bind(this);
    this.updateCount = this.updateCount.bind(this);
    this.toggleWinsPositiveOutcomeList = this.toggleWinsPositiveOutcomeList.bind(this);
    this.toggleRpmCarePlanList = this.toggleRpmCarePlanList.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    if (name === "confirmpassword") {
      const checkMatch = this.state.password === value;

      if (!checkMatch) {
        this.setState({ errorPassword: true });
      } else {
        this.setState({ errorPassword: false });
      }
    }
  }
  handleRole(e){
    this.setState({ role: e == null ? "" : e.target.value });
  }
  resetStateBack() {
    this.setState({
      modal2: false,
      modal: false,
      modalUser: false,
      modalReset: false,
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      subOrganization: "",
      gender: "Male",
      role: "",
      isClient: true,
      resetFullname: "",
      resetPatientId: "",
      sharedmodal: false,
      modalShared: false,
    });
  }
  resetForm() {
    this.setState({
      modal2: false,
      modal: false,
      modalUser: false,
      modalReset: false,
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      subOrganization: "",
      gender: "Male",
      role: "",
      isClient: true
    });
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
    // this.props.dispatch({
    //   type: "DO_GET_USERS_YOU_HAVE_ACCESS",
    //   payload: { client: true }
    // });
    this.setState({
      selectedApi: MENU_API.ACTIVE_PATIENT,
      displayActiveList: true,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard : false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false
    }, () => {
      this.fetchData();
    });
    // this.props.dispatch({
    //   type: "DO_GET_USERS_READING_UNDER_YOUR_ORGANIZATION"
    // });
  }

  submitUser(e) {
    e.preventDefault();
    if (this.state.errorPassword) {
      return;
    }
    const userData = {
      fname : this.state.fname,
      lname : this.state.lname,
      nickname : this.state.nickname,
      username : this.state.username,
      email : this.state.email,
      phone : this.state.phone,
      homeNumber : this.state.homeNumber,
      workNumber : this.state.workNumber,
      address : this.state.address,
      city : this.state.city,
      state : this.state.state,
      zip : this.state.zip,
      weight : this.state.weight,
      height : this.state.height,
      bday : this.state.bday,
      memberId : this.state.memberId,
      organization : this.state.organization,
      subOrganization : this.state.subOrganization,
      gender: this.state.gender,
      insuranceProvider : this.state.insuranceProvider,
      enrolledPrograms : this.state.enrolledPrograms,
      role : this.state.role,
      approvalStatus : this.state.approvalStatus,
      password : this.state.password
    }

    this.props.dispatch({
      type: "DO_SAVE_USER",
      payload: userData
    });
  }
  submitReset(e) {
    e.preventDefault();
    if (this.state.errorPassword) {
      return;
    }
    this.setState({
      showWarning: !this.state.showWarning
    });
  }
  submitShared(e) {
    e.preventDefault();
    if (this.state.errorPassword) {
      return;
    }
    const cleanUser = omit(this.state, [
      "activeTab",
      "modal",
      "modal2",
      "sharedmodal",
      "modalShared",
      "modalUser",
      "modalReset",
      "emailOffer",
      "confirmpassword",
      "emailAccess",
      "showAlertSuccess",
      "errorPassword",
      "resetFullname",
      "resetPatientId",
      "showWarning",
      "displayActiveList",
      "displayDemoList",
      "displayCellularConnectivityList",
      "displayNeedToFollowUpList",
      "displayWinsPositiveOutcome",
      "loading",
      "selectedApi",
      "isClient",
      "careprovider",
    ]);
    this.props.dispatch({
      type: "DO_SAVE_SHARED",
      payload: cleanUser
    });
  }
  toggleShared() {
    const previousState = this.state.modalShared;

    this.setState({
      modalShared: !this.state.modalShared
    });
    if (previousState) {
      this.resetForm();
    }
  }
  submitResetPassword() {
    this.props.dispatch({
      type: "DO_RESET_PATIENT_PASSWORD",
      payload: {
        user: this.state.resetPatientId,
        password: this.state.password
      }
    });
    this.setState({
      showWarning: !this.state.showWarning
    });
  }
  toggleUser() {
    const previousState = this.state.modalUser;

    this.setState({
      modalUser: !this.state.modalUser
    });
    if (previousState) {
      this.resetForm();
    }
  }
  toggleReset(fullname, patientId) {
    const previousState = this.state.modalReset;

    this.setState({
      modalReset: !this.state.modalReset,
      resetFullname: fullname,
      resetPatientId: patientId
    });
    if (previousState) {
      this.resetStateBack();
    }
  }
  toggleModal() {
    const previousState = this.state.modalUser;

    this.setState({
      modalUser: !this.state.modalUser
    });
    if (previousState) {
      this.resetForm();
    }
  }
  toggleSharedModal() {
    this.setState({
      sharedmodal: !this.state.sharedmodal
    });
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggleDisplayActiveList(display) {
    if (display) {
      //Display active list
      this.setState({
        selectedApi: MENU_API.ACTIVE_PATIENT,
        displayActiveList: true,
        displayDemoList: null,
        displayCellularConnectivityList: false,
        displayWinsPositiveOutcome: false,
        displayRpmCarePlanList: false,
        displayNeedToFollowUpList: false,
        displayHospitalAddmissionList: false,
        displayItIssuesList : false,
        displayFollowUpReminderList : false,
        displayReminderSentList : false,
        displayWarningAdherence: false,
        displayfollowUpPhoneCall: false,
        displayMonthlyCheckInPhoneCall: false,
        displayEducationMaterialCard : false
      }, () => {
        this.fetchData();
      });
      this.setQueryParams({tab : patientsTab.active})
    } else {
      // inactive list clicked
      this.setState({
        selectedApi: MENU_API.IN_ACTIVE_PATIENT,
        displayActiveList: false,
        displayDemoList: null,
        displayCellularConnectivityList: false,
        displayWinsPositiveOutcome: false,
        displayRpmCarePlanList: false,
        displayNeedToFollowUpList: false,
        displayHospitalAddmissionList: false,
        displayItIssuesList : false,
        displayFollowUpReminderList : false,
        displayReminderSentList : false,
        displayWarningAdherence: false,
        displayfollowUpPhoneCall : false,
        displayMonthlyCheckInPhoneCall :  false,
        displayEducationMaterialCard : false
      }, () => {
        this.fetchData();
      });
      this.setQueryParams({tab : patientsTab.inActive})
    }

  }

  toggleCellularConnectivityList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.CALLER_PATIENT,
      displayCellularConnectivityList: true,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.cellurConnectivity})
  }

  toggleNeedToFollowUpList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.NEED_TO_FOLLOW_UP,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: true,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.needToFollowUp})
  }

  toggleHospitalAdmissionList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.HOSPITAL_ADMINSSON,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: true,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.hospitalAdmission})
  }
  toggleItIssueslAdmissionList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.IT_ISSUES,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : true,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.itIssue})
  }
  toggleFollowUpRemindersList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.FOLLOW_UP_REMINDERS,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : true,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.followUpReminders})
  }
  toggleRemindeSentList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.REMINDER_SENT,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : true,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.reminderSent})
  }
  toggleMonthlyCheckInPhoneCallList(){
    this.setState({
      selectedApi: MENU_API.MONTHLY_CHECK_IN_PHONE_CALL,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  true,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.monthlyCheckInPhoneCall})
  }
  toggleFollowUpPhoneCallList(){
    this.setState({
      selectedApi: MENU_API.FOLLOW_UP_PHONE_CALL,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : true,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.followUpPhoneCall})
  }
  toggleDemoList(){
    this.setState({
      selectedApi: MENU_API.DEMO_PATIENT,
      displayDemoList: true,
      displayActiveList: null,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.demo})

  }
  toggleAllPatientsList(){
    this.setState({
      displayDemoList: false,
      displayActiveList: null,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayItIssuesList : false,
      selectedApi: MENU_API.ALL_PATIENT,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.all})
  }
  setQueryParams(newParams){
    const currentParams = queryString.parse(window.location.search);
    // Merge current and new query parameters
    const updatedParams = { ...currentParams, ...newParams };

    // Create the new query string
    const newQueryString = queryString.stringify(updatedParams);

    // Update the URL with new query params
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?${newQueryString}`,
    });
  }
  toggleWarningAdherenceList() {
    //Display cellular connectivity list        
    this.setState({
      selectedApi: MENU_API.WANRNING_ADHERENCE,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: true,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.didNotQualifyLastMonth})
  }
  toggleDemoList(){
    this.setState({
      selectedApi: MENU_API.DEMO_PATIENT,
      displayDemoList: true,
      displayActiveList: null,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.demo})

  }
  toggleAllPatientsList(){
    this.setState({
      displayDemoList: false,
      displayActiveList: null,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayItIssuesList : false,
      selectedApi: MENU_API.ALL_PATIENT,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab : patientsTab.all})
  }
  toggleEducationMaterialCard(){
    this.setState({
      selectedApi: MENU_API.WANRNING_ADHERENCE,
      displayCellularConnectivityList: false,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayItIssuesList : false,
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : true
    });
    this.setQueryParams({tab : patientsTab.educationMaterial})
  }
  toggleWinsPositiveOutcomeList() {
    this.setState({
      selectedApi: MENU_API.WINS_POSITIVE_OUTCOME,
      displayWinsPositiveOutcome: true,
      displayRpmCarePlanList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayItIssuesList: false,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false
    }, () => {
      this.fetchData();
    });
    this.setQueryParams({tab: patientsTab.winsPositiveOutcome});
  }
  toggleRpmCarePlanList() {
    this.setState({
      selectedApi: MENU_API.RPM_CARE_PLAN,
      displayRpmCarePlanList: true,
      displayWinsPositiveOutcome: false,
      displayActiveList: null,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAddmissionList: false,
      displayItIssuesList: false,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayWarningAdherence: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false
    });
    this.setQueryParams({tab: patientsTab.rpmCarePlan});
  }
  updateEducationCount(event){
  if(event){
    this.setState({educationPatientsCount : event})
  }
  }
  updateCount(event) {
    if (event) {
      this.setState({ hospitalPatientsCount: event })
    }else if(event === 0){
       this.setState({ hospitalPatientsCount: 0 })
    }
  }
  setQueryParams(newParams){
    const currentParams = queryString.parse(window.location.search);
    // Merge current and new query parameters
    const updatedParams = { ...currentParams, ...newParams };

    // Create the new query string
    const newQueryString = queryString.stringify(updatedParams);

    // Update the URL with new query params
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?${newQueryString}`,
    });
  }
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
    this.props.dispatch({
      type: "DO_GET_ALL_PATIENT_COUNT"
    });
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
    this.props.dispatch({
      type: "DO_REMOVE_PROFILE_DATA"
    });
    this.props.dispatch({
      type: "DO_GET_CREATE_PATIENT_PERMISSION"
    });
    // this.props.dispatch({
    //   type: "DO_GET_USERS_YOU_HAVE_ACCESS",
    //   payload: { client: true }
    // });
    this.props.dispatch({
      type: "DO_GET_PROFILE",
      payload: { authProfile: true }
    });
    // this.props.dispatch({
    //   type: "DO_GET_USERS_READING_UNDER_YOUR_ORGANIZATION"
    // });
    const { tab } = queryString.parse(window.location.search);
    if(tab == patientsTab.all){
      this.toggleAllPatientsList();
    }else if(tab == patientsTab.active){
      this.toggleDisplayActiveList(true)
    }else if(tab == patientsTab.inActive){
      this.toggleDisplayActiveList(false)
    }else if(tab == patientsTab.demo){
      this.toggleDemoList();
    }else if(tab == patientsTab.cellurConnectivity){
      this.toggleCellularConnectivityList();
    }else if(tab == patientsTab.needToFollowUp){
      this.toggleNeedToFollowUpList()
    }else if(tab == patientsTab.hospitalAdmission){
      this.toggleHospitalAdmissionList()
    }else if(tab == patientsTab.reminderSent){
      this.toggleRemindeSentList()
    }else if(tab == patientsTab.followUpReminders){
      this.toggleFollowUpRemindersList()
    }else if(tab == patientsTab.itIssue){
      this.toggleItIssueslAdmissionList()
    }else if(tab == patientsTab.didNotQualifyLastMonth){
      this.toggleWarningAdherenceList()
    }else if(tab == patientsTab.followUpPhoneCall){
      this.toggleFollowUpPhoneCallList()
    }else if(tab == patientsTab.monthlyCheckInPhoneCall){
      this.toggleMonthlyCheckInPhoneCallList()
    }else if(tab == patientsTab.educationMaterial){
      this.toggleEducationMaterialCard()
    }else if(tab == patientsTab.winsPositiveOutcome){
      this.toggleWinsPositiveOutcomeList()
    }else if(tab == patientsTab.rpmCarePlan){
      this.toggleRpmCarePlanList()
    }
    // else{
    //   this.toggleDisplayActiveList(true)
    // }
  }
  render() {
    const numberActive = this.props.allPatientCount ? this.props.allPatientCount.activePatients : 0;
    const numberInactive = this.props.allPatientCount ? this.props.allPatientCount.inActivePatients : 0;
    const numberDemo = this.props.allPatientCount ? this.props.allPatientCount.demoPatients : 0;
    const allPatients = this.props.allPatientCount ? this.props.allPatientCount.allPatients : 0;
    const numberCellularConnectivity = this.props.allPatientCount ? this.props.allPatientCount.cellularConnectivityPatients : 0;
    const needToFollowUp = this.props.allPatientCount ? this.props.allPatientCount.needToFollowUp : 0;
    const hospitalAddmission = this.state.hospitalPatientsCount ? this.state.hospitalPatientsCount : this.props.allPatientCount ? this.props.allPatientCount.hospitalAddmission : 0;
    const itIssues = this.props.allPatientCount ? this.props.allPatientCount.itIssues : 0;
    const followUpReminders = this.props.allPatientCount && this.props.allPatientCount.followUpReminders ? this.props.allPatientCount.followUpReminders : 0;
    const reminderSent = this.props.allPatientCount && this.props.allPatientCount.reminderSent ? this.props.allPatientCount.reminderSent : 0;
    const warningAdherences = this.props.allPatientCount && this.props.allPatientCount.warningAdherences ? this.props.allPatientCount.warningAdherences : 0;
    const monthlyCheckInPhoneCall = this.props.allPatientCount && this.props.allPatientCount.monthlyCheckInPhoneCall ? this.props.allPatientCount.monthlyCheckInPhoneCall : 0;
    const followUpPhoneCall = this.props.allPatientCount && this.props.allPatientCount.followUpPhoneCall ? this.props.allPatientCount.followUpPhoneCall : 0;
    const educationMaterial = this.state.educationPatientsCount ? this.state.educationPatientsCount : this.props.allPatientCount && this.props.allPatientCount.educationMaterialPatients ? this.props.allPatientCount.educationMaterialPatients : 0;
    const rpmCarePlanCount = this.props.allPatientCount && this.props.allPatientCount.rpmCarePlanCount ? this.props.allPatientCount.rpmCarePlanCount : 0;

    // Determine active card for highlighting
    const getActiveCardId = () => {      
      if (this.state.selectedApi === MENU_API.ALL_PATIENT) return 'all';
      if (this.state.displayActiveList === true) return 'active';
      if (this.state.displayActiveList === false) return 'inactive';
      if (this.state.displayDemoList) return 'demo';
      if (this.state.displayCellularConnectivityList) return 'cellular';
      if (this.state.displayNeedToFollowUpList) return 'followUp';
      if (this.state.displayHospitalAddmissionList) return 'hospital';
      if (this.state.displayItIssuesList) return 'itIssues';
      if (this.state.displayFollowUpReminderList) return 'followUpReminder';
      if (this.state.displayReminderSentList) return 'reminderSent';
      if (this.state.displayWarningAdherence) return 'warning';
      if (this.state.displayfollowUpPhoneCall) return 'followUpPhone';
      if (this.state.displayMonthlyCheckInPhoneCall) return 'monthlyCheckIn';
      if (this.state.displayEducationMaterialCard) return 'education';
      if (this.state.displayWinsPositiveOutcome) return 'wins';
      if (this.state.displayRpmCarePlanList) return 'rpmCarePlan';
      return null;
    };

    const activeCardId = getActiveCardId();

    const winsPositiveOutcome = this.props.allPatientCount ? this.props.allPatientCount.winsPositiveOutcome : 0;

    // Dashboard cards configuration
    const cards = [
      { id: 'all', title: 'All', count: allPatients, icon: 'mdi mdi-account-group', color: 'blue', onClick: () => this.toggleAllPatientsList() },
      { id: 'active', title: 'Active', count: numberActive, icon: 'mdi mdi-account-check', color: 'blue', onClick: () => this.toggleDisplayActiveList(true) },
      { id: 'demo', title: 'Demo', count: numberDemo, icon: 'mdi mdi-presentation', color: 'blue', onClick: () => this.toggleDemoList() },
      { id: 'inactive', title: 'Inactive', count: numberInactive, icon: 'mdi mdi-account-off', color: 'blue', onClick: () => this.toggleDisplayActiveList(false) },
      { id: 'cellular', title: 'Cellular Connectivity', count: numberCellularConnectivity, icon: 'mdi mdi-signal', color: 'blue', onClick: () => this.toggleCellularConnectivityList() },
      { id: 'followUp', title: 'Need To Follow Up', count: needToFollowUp, icon: 'mdi mdi-alert-circle', color: 'blue', onClick: () => this.toggleNeedToFollowUpList() },
      { id: 'hospital', title: 'Hospital Admission', count: hospitalAddmission, icon: 'mdi mdi-hospital-building', color: 'blue', onClick: () => this.toggleHospitalAdmissionList() },
      { id: 'itIssues', title: 'IT Issues', count: itIssues, icon: 'mdi mdi-wrench', color: 'blue', onClick: () => this.toggleItIssueslAdmissionList() },
      { id: 'followUpReminder', title: 'Follow Up Reminders', count: followUpReminders, icon: 'mdi mdi-bell', color: 'blue', onClick: () => this.toggleFollowUpRemindersList() },
      { id: 'followUpPhone', title: 'Follow Up Phone Call', count: followUpPhoneCall, icon: 'mdi mdi-phone', color: 'blue', onClick: () => this.toggleFollowUpPhoneCallList() },
      { id: 'monthlyCheckIn', title: 'Monthly Check in Phone Call', count: monthlyCheckInPhoneCall, icon: 'mdi mdi-phone-in-talk', color: 'blue', onClick: () => this.toggleMonthlyCheckInPhoneCallList() },
      { id: 'reminderSent', title: 'Reminder Sent', count: reminderSent, icon: 'mdi mdi-check-circle', color: 'blue', onClick: () => this.toggleRemindeSentList() },
      { id: 'warning', title: 'Did Not Qualify Last Month', count: warningAdherences, icon: 'mdi mdi-close-circle', color: 'blue', onClick: () => this.toggleWarningAdherenceList() },
      { id: 'education', title: 'Educational Material', count: educationMaterial, icon: 'mdi mdi-book-open-variant', color: 'blue', onClick: () => this.toggleEducationMaterialCard() },
      { id: 'wins', title: 'WINS - Positive Outcome', count: winsPositiveOutcome, icon: 'mdi mdi-trophy', color: 'blue', onClick: () => this.toggleWinsPositiveOutcomeList() },
      { id: 'rpmCarePlan', title: 'RPM Care Plan', count: rpmCarePlanCount, icon: 'mdi mdi-clipboard-text', color: 'blue', onClick: () => this.toggleRpmCarePlanList() }
    ];

    return (
      <div>
        <div className="row">
          <Heading
            title="PATIENTS"
            description=""
            toggleModal={this.toggleModal}
            toggleSharedModal={this.toggleSharedModal}
            backbutton="d-none"
            mainbutton="d-block"
            checkPermission = {this.props.createPatientPermission}
          >
            <span className="page-title-icon bg-gradient-danger   text-white mr-2">
              <i className="mdi mdi-account-convert" />
            </span>
          </Heading>
          <div className="col-12 grid-margin remove-pading-table">
            <div className="card">
              <div className="card-body project-tab pt-2">
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                    <img className="img-tabsfluid mr-2" src={usersImage} />
                      PATIENTS
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row>
                  <Col sm="12" className="grid-margin mt-4 remove-pading-table">
                    {!this.props.allPatientCount && (
                      <ReactLoading className="mx-auto" color={"#007bff"} />
                    )}
                    {this.props.allPatientCount && (
                      <div>
                        <div className="dashboard-container">
                          {cards.map((card) => (
                            <DashboardCard
                              key={card.id}
                              title={card.title}
                              count={card.count}
                              icon={card.icon}
                              color={card.color}
                              onClick={card.onClick}
                              isActive={activeCardId === card.id}
                            />
                          ))}
                        </div>
                        {this.state.displayEducationMaterialCard ? (
                          <EducationMaterialSentPatients updateEducationCount={this.updateEducationCount}/>
                        ) : this.state.displayRpmCarePlanList ? (
                          <RpmCarePlanList />
                        ) : (
                          <ActivePatientList
                            fetchDataFromServer={(click) => (this.fetchData = click)}
                            selectedApi={this.state.selectedApi}
                            profileOwner={this.props.profileOwner}
                            toggleReset={this.toggleReset}
                            readingSubTypes={this.props.readingSubTypes}
                            userId={this.props.userId}
                            deletePermission={this.deletePermission}
                            approvePermission={this.approvePermission}
                            receivedFrom={false}
                            displayActiveList={this.state.displayActiveList}
                            displayCellularConnectivityList={this.state.displayCellularConnectivityList}
                            displayNeedToFollowUpList={this.state.displayNeedToFollowUpList}
                            displayHospitalAddmissionList={this.state.displayHospitalAddmissionList}
                            displayItIssuesList={this.state.displayItIssuesList}
                            displayWinsPositiveOutcome={this.state.displayWinsPositiveOutcome}
                            displayFollowUpReminderList={this.state.displayFollowUpReminderList}
                            displayReminderSentList={this.state.displayReminderSentList}
                            displayWarningAdherence={this.state.displayWarningAdherence}
                            displayMonthlyCheckInPhoneCall={this.state.displayMonthlyCheckInPhoneCall}
                            displayfollowUpPhoneCall={this.state.displayfollowUpPhoneCall}
                            updateCount={this.updateCount}
                          />
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        <SweetAlert
          success
          title="Success!"
          show={this.props.isGenericSuccess}
          onConfirm={this.resetForm}
          confirmBtnBsStyle="info"
        >
          {/* {!this.state.bday && (
            <div>
              Submitted Successfully Invitation is Sent to {this.state.email}
            </div>
          )} */}
          <div>Your action is successful</div>
        </SweetAlert>
        <SweetAlert
          warning
          showCancel
          show={this.state.showWarning}
          confirmBtnText="Yes, reset the password now!"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          title="Are you sure?"
          onConfirm={this.submitResetPassword}
          onCancel={this.submitReset}
        >
          This will change the password of these user
        </SweetAlert>
        <Modal
          isOpen={this.state.sharedmodal}
          toggle={this.toggleSharedModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleSharedModal}>
            Create a New Shared Account
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <h5 className="text-center" />
            <div className="row">
              <div className="col-12 mx-auto">
                <NavLink
                  className="text-center d-block"
                  onClick={this.toggleShared}
                >
                  <img src={familyAccount} style={{ height: "180px" }} />
                  <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                    CREATE A NEW SHARED ACCOUNT
                  </span>
                  <small>You will input everything</small>
                </NavLink>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR"
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        >
          Error Code: {this.props.genericErrorMessage.error}
        </SweetAlert>
        <CreateSharedAccountModal
        modalUser={this.state.modalShared}
        toggleUser={this.toggleShared}
        errorPassword={this.state.errorPassword}
        submitUser={this.submitShared}
        handleInputChange={this.handleInputChange}
        handleRole={this.handleRole}
        />
        <ResetPassword
          modalReset={this.state.modalReset}
          toggleReset={this.toggleReset}
          fullname={this.state.resetFullname}
          errorPassword={this.state.errorPassword}
          submitReset={this.submitReset}
          handleInputChange={this.handleInputChange}
        />
        <CreateUserModal
          modalUser={this.state.modalUser}
          toggleUser={this.toggleUser}
          errorPassword={this.state.errorPassword}
          submitUser={this.submitUser}
          handleInputChange={this.handleInputChange}
          userDetails={this.state}
          handleRole={this.handleRole}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user, auth }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    usersOfferedAccessOrganization,
    allPatientCount,
    ongoingRequest,
    createPatientPermission
  } = careprovider;
  const { readingSubTypes } = auth;
  const userId = user.userDetails._id;
  const profileOwner = user.profileOwner;
  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    readingSubTypes,
    usersOfferedAccessOrganization,
    userId,
    profileOwner,
    allPatientCount,
    ongoingRequest,
    createPatientPermission
  };
};

export default connect(mapStateToProps)(AdminAnalytics);
